<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 财务管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>记账对账</el-breadcrumb-item>
				<el-breadcrumb-item>会计代码扩展</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.code" placeholder="系统会计编码" class="handle-input mr10"></el-input>
                <el-input v-model="query.extendCode" placeholder="扩展会计编码" class="handle-input mr10"></el-input>
                <el-input v-model="query.name" placeholder="名称" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>&nbsp;&nbsp;
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="code" label="系统会计编码" width="180px"></el-table-column>
				<el-table-column prop="extendCode" label="扩展会计编码" width="200px"></el-table-column>
				<el-table-column prop="name" label="名称"></el-table-column>
				<el-table-column prop="attributionType" label="属性" width="120" :formatter="attributionTypeFormater"></el-table-column>
                <el-table-column label="操作" width="150px" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
							class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<!-- <div class="record-a-d">
				<el-button
					style="float:left"
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div> -->
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="35%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-form-item label="系统会计编码" prop="code">
					<el-input v-model="form.code" placeholder="系统会计编码" disabled style ="width:90%;"></el-input>
                </el-form-item>
				<el-form-item label="扩展会计代码" prop="extendCode">
					<el-input v-model="form.extendCode" placeholder="扩展会计代码" style ="width:90%;"></el-input>
                </el-form-item>
				<el-form-item label="名称" prop="name">
					<el-input v-model="form.name" placeholder="名称" style ="width:90%;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="系统会计编码" :visible.sync="codeVisible" width="35%">
            <el-tree :data="data" :props="codeTreeData" @node-click="handleNodeClick"></el-tree>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchAccountingExtendData, saveAccountingExtend, deleteAccountingExtend, getAccountingExtend, 
fetchAccountingTreeData, getAttributionTypeKV } from '../../../api/index';
export default {
    name: 'accounting-extend',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
			title:"",
			rules: {
				code: [{ required: true, message: '请选择会计编码', trigger: 'blur' }],
                extendCode: [{ required: true, message: '请输入扩展会计编码', trigger: 'blur' }],
				name: [{ required: true, message: '请输入细分名称', trigger: 'blur' }]
            },
			controll:{},
			codeVisible:false,
			codeTreeData:[],
			attributionTypeKV:[]
        };
    },
    created() {
		this.controll = getControll("accounting-extend");
		this.getAttributionType();
        this.getData();
    },
    methods: {
		//获取会计代码属性
		getAttributionType(){
            getAttributionTypeKV().then(res => { 
				if (res.code == 0 ) {
					this.attributionTypeKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		//会计属性格式化
		attributionTypeFormater(row, column, cellValue){
			let index = this.attributionTypeKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.attributionTypeKV[index].value;
		},
        // 获取数据
        getData() {
            fetchAccountingExtendData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteAccountingExtend([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.uuid = "";
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
			getAccountingExtend(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveAccountingExtend(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
